import { Button, Modal, Select } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useAppDispatch, useAppSelector } from '../../../Reducers/store';
import { UserTerritory } from '../../../Models/UserTerritory';
import UserApi from '../../../Api/UserApi';
import { fetchTerritoryList } from '../../../Actions/CommonFields';

export default function AddUserTerritoryModal({
  show,
  setShow,
  getUserTerritorys,
  userId,
  userTerritory,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  userId: number;
  getUserTerritorys: () => Promise<void> | undefined;
  userTerritory: UserTerritory | null;
}) {
  const dispatch = useAppDispatch();
  const { territories } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [formData, setFormData] = useState<UserTerritory>({
    id: 0,
    userId: userId,
    territoryId: null,

    territory: null,
  });

  const getReferences = async () => {
    if (!territories.length) {
      await Promise.all([dispatch(fetchTerritoryList())]);
    }
  };

  useEffect(() => {
    if (show === true) {
      getReferences();
    }
  }, [show]);

  const handleSetInitialValues = () => {
    const values = userTerritory
      ? {
          ...userTerritory,
        }
      : {
          id: 0,
          userId: userId,
          territoryId: 1,

          territory: null,
        };
    setFormData(values as UserTerritory);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [userTerritory]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      userId: userId,
      territoryId: 1,

      territory: null,
    };
    setFormData(values as UserTerritory);
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    await UserApi.addUpdateUserTerritory(formData)
      .then((res) => {
        if (res.data.success) {
          getUserTerritorys();
          onCloseModal();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error('Error: ' + err);
        setIsLoading(false);
      });
  };

  function onCloseModal() {
    handleResetFormValues();
    setButtonDisabled(false);
    setIsLoading(false);
    setShow(false);
  }

  return (
    <Modal show={show} size='4xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  User Territory
                </h1>
              </div>
            </div>
          </div>

          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <form>
                      <div className='text-gray-500'>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Territory:
                            </div>
                          </div>
                          <div className='w-full'>
                            <Select
                              id='territoryId'
                              name='territoryId'
                              onChange={handleChangeSelect}
                              value={formData.territoryId ?? 1}
                              sizing='md'
                              required
                            >
                              {territories.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                  {'-'}
                                  {item.number}
                                </option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          disabled={buttonDisabled}
                          type='button'
                          className='buttonMain'
                          onClick={() => onSubmit()}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
